<template>
    <div class="left_panel design_studio_panel_pd my_design_new">
        <div>
            <div
                class="tools_headding select_catgory_headding w-100 heading-pd"
                style=""
            >
                <h4 class="heading5">
                    <span id="my-design">My Designs</span>
                </h4>
                <a
                    href="javascript:;"
                    @click="closeMenu('designs')"
                    class="ml-auto"
                    title="Close"
                >
                    <img src="/maincss/images/tool_close.svg" alt="Close" />
                </a>
            </div>
            <div class="serach s-r-12 mb-0">
                <div class="search_field position-relative mg-b-12">
                    <label class="s-r-3"> Search</label>
                    <input
                        type="text"
                        placeholder="Search Design"
                        v-model="design_search_query"
                        class="form-control bg-transparent s-r-9"
                    />
                </div>
            </div>

            <div class="row my_design_fields">
                <div class="col-md-6">
                    <fieldset class="form-group mt-0">
                        <v-select
                            label="title"
                            :reduce="(data) => data.id"
                            :options="all_category_list"
                            :placeholder="'Select Categories'"
                            v-model="listConfig.category_id"
                            @input="onChangeCategoryFilter"
                        ></v-select>
                    </fieldset>
                </div>
                <div class="col-md-6">
                    <fieldset class="form-group mt-0">
                        <v-select
                            label="attribute_set_name"
                            :reduce="(data) => data.id"
                            :options="all_attribute_sets_list"
                            :placeholder="'Select Attributes'"
                            v-model="listConfig.attribute_set_id"
                            @input="onChangeAttributeSetFilter"
                        ></v-select>
                    </fieldset>
                </div>
            </div>

            <!-- Design Listing -->
            <div
                v-if="saved_design_search().length > 0"
                class="categorys_open my-design my_design_new"
            >
                <div
                    v-for="(saved_designs, index) in saved_design_search()"
                    :key="index"
                    class="design_section"
                >
                    <div
                        @click="setNewDesign(saved_designs.id)"
                        class="cursor-pointer"
                        v-if="saved_designs.front_image"
                        :class="
                            current_design_id == saved_designs.id
                                ? 'design_block active_design'
                                : 'design_block'
                        "
                    >
                        <h3
                            :attribute_sets="saved_designs.attribute_sets"
                            :category_ids="saved_designs.category_ids"
                        >
                            {{ saved_designs.name }}
                        </h3>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="design_items">
                                    <div class="items">
                                        <h5>Front</h5>
                                        <img
                                            :src="saved_designs.front_image"
                                            alt=""
                                        />
                                        <div
                                            v-html="
                                                designColorsHtml(
                                                    saved_designs.front_color
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="design_items">
                                    <div class="items">
                                        <h5>Back</h5>
                                        <img
                                            :src="saved_designs.back_image"
                                            alt=""
                                        />
                                        <div
                                            v-html="
                                                designColorsHtml(
                                                    saved_designs.back_color
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="design_items">
                                    <div class="items">
                                        <h5>Left</h5>
                                        <img
                                            :src="saved_designs.left_image"
                                            alt=""
                                        />
                                        <div
                                            v-html="
                                                designColorsHtml(
                                                    saved_designs.left_color
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="design_items">
                                    <div class="items">
                                        <h5>Right</h5>
                                        <img
                                            :src="saved_designs.right_image"
                                            alt=""
                                        />
                                        <div
                                            v-html="
                                                designColorsHtml(
                                                    saved_designs.right_color
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="delete_button"
                            @click="
                                $event.stopPropagation();
                                deleteDesign(saved_designs.id);
                            "
                        >
                            <img
                                src="/maincss/design-images/delete.svg"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-else
                class="serach s-r-12 blank_data_design_custom mrg_no_image"
            >
                No designs saved.
            </div>
        </div>

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "MyDesigns",
    props: ["current_design_id", "design_tab_active"],
    data() {
        return {
            isLoader: false,
            design_search_query: null,
            listConfig: {
                category_id: null,
                attribute_set_id: null
            },
            saved_design_list: [],
            all_category_list: [],
            all_attribute_sets_list: []
        };
    },
    components: {},
    computed: {},
    watch: {
        design_tab_active() {
            if (this.design_tab_active) {
                this.getAllSavedDesign();
            }
        }
    },
    mounted() {
        this.getAllSavedDesign();
        if (this.all_category_list.length == 0) {
            this.getAllCategories();
        }
        if (this.all_attribute_sets_list.length == 0) {
            this.getAllAttributeSets();
        }
    },
    methods: {
        isJSON(str) {
            try {
                JSON.parse(str);
                return true;
            } catch (error) {
                return false;
            }
        },
        getAllSavedDesign() {
            let _this = this;
            ApiService.query("/get-design-image-v2", {
                params: this.listConfig
            })
                .then(({ data }) => {
                    _this.saved_design_list = data.design;
                    _this.isLoader = false;
                })
                .catch(({ response }) => {
                    console.log(response);
                    _this.isLoader = false;
                });
        },
        closeMenu() {
            this.$emit("close-design");
        },
        saved_design_search() {
            if (this.design_search_query) {
                return this.saved_design_list.filter((item) => {
                    return item.name
                        .toLowerCase()
                        .includes(this.design_search_query.toLowerCase());
                });
            } else {
                return this.saved_design_list || [];
            }
        },
        setNewDesign(design_id) {
            this.$emit("set-new-design", design_id);
        },
        deleteDesign(design_id) {
            if (confirm("Do you really want to delete?")) {
                this.isLoader = true;
                ApiService.delete("/delete-saved-design/" + design_id)
                    .then(() => {
                        this.$toast.success("Design deleted successfully", {
                            position: "top-right"
                        });
                        this.getAllSavedDesign();
                    })
                    .catch(({ response }) => {
                        console.log("Error Response", response);
                    });
            }
        },
        designColorsHtml(colors) {
            let output = "";
            if (colors == null) return output;
            if (colors !== null && colors !== "null" && this.isJSON(colors)) {
                let colorsParse = JSON.parse(colors).length
                    ? JSON.parse(colors)
                    : [];
                if (!colorsParse.length > 0) return output;

                let limitColorsArr =
                    colorsParse.length > 4
                        ? colorsParse.slice(0, 4)
                        : colorsParse;
                if (!Array.isArray(limitColorsArr)) return output;

                output += `<ul>`;
                limitColorsArr.forEach((element) => {
                    output += `<li style="background-color: ${element.hex};"></li>`;
                });
                if (colorsParse.length > 4) {
                    output += `<li class="more_color_link"><a href="javascript:;">+${
                        colorsParse.slice(4).length
                    }</a></li>`;
                }
                output += `</ul>`;
            }
            return output;
        },
        onChangeCategoryFilter() {
            this.listConfig.attribute_set_id = null;
            this.getAllAttributeSets();
            this.getAllSavedDesign();
        },
        onChangeAttributeSetFilter() {
            this.getAllSavedDesign();
        },
        getAllCategories() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-all-categories-list")
                    .then(({ data }) => {
                        this.all_category_list = data.categories;
                        this.all_category_list.unshift({
                            id: "All",
                            title: "All"
                        });
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllAttributeSets() {
            let params = {
                attributes: ["id", "attribute_set_name"],
                category_id: this.listConfig.category_id || undefined
            };
            return new Promise((resolve, reject) => {
                ApiService.query("/get-attribute-sets", { params })
                    .then(({ data }) => {
                        this.all_attribute_sets_list = data.attributes;
                        this.all_attribute_sets_list.unshift({
                            id: "All",
                            attribute_set_name: "All"
                        });
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        }
    }
};
</script>
